import { SVG_PROP_TYPE } from '../vectorImage/constants'; // PropTypes

export var ILLUSTRATION_TYPE_PROP_TYPE = SVG_PROP_TYPE;